document.addEventListener("DOMContentLoaded", function () {
  var mainSelect = document.querySelector("[data-main-category-select]");
  var subCategoryFields = document.querySelectorAll(
    "[data-sub-category-field]"
  );

  if (!mainSelect || subCategoryFields.length === 0) return;

  function toggleSubCategories() {
    var selectedCategory = mainSelect.value.trim();

    // Hide all sub-category fields first
    subCategoryFields.forEach(function (field) {
      field.setAttribute("hidden", true);
      field.style.display = "none";
      // Reset sub-category select when hidden
      var subSelect = field.querySelector("select");
      if (subSelect) {
        subSelect.selectedIndex = 0;
        // Remove required attribute when hidden
        subSelect.removeAttribute("required");
      }
      // Reset text input when hidden
      var textInput = field.querySelector('input[type="text"]');
      if (textInput) {
        textInput.value = "";
        // Remove required attribute when hidden
        if (textInput.hasAttribute("data-required-when-visible")) {
          textInput.removeAttribute("required");
        }
      }
    });

    // Show the sub-category field that matches the selected category
    if (selectedCategory) {
      subCategoryFields.forEach(function (field) {
        var triggerCategory = (
          field.getAttribute("data-trigger-category") || ""
        ).trim();
        if (triggerCategory === selectedCategory) {
          field.removeAttribute("hidden");
          field.style.display = "";
          // Add required attribute to inputs that should be required when visible
          var textInput = field.querySelector('input[type="text"][data-required-when-visible]');
          if (textInput) {
            textInput.setAttribute("required", "required");
          }
        }
      });
    }
  }

  // Initial check
  toggleSubCategories();

  // Listen for changes
  mainSelect.addEventListener("change", toggleSubCategories);

  // Ensure form can submit properly
  var contactForm = document.getElementById("ContactForm");
  if (contactForm) {
    contactForm.addEventListener("submit", function (e) {
      // Remove required attribute from hidden fields before validation
      subCategoryFields.forEach(function (field) {
        if (field.hasAttribute("hidden") || field.style.display === "none") {
          var inputs = field.querySelectorAll("input[required], select[required]");
          inputs.forEach(function (input) {
            input.removeAttribute("required");
          });
        }
      });
      // Let the form submit naturally - Shopify will handle it
    });
  }
});
